import React from "react";
import { ThemeProvider } from "./context/ThemeContext";
import Home from "./pages/Home";
import MojaFinance from "./pages/MojaFinance";
import Contact from "./pages/Contact";
import { usePathname } from "./router";

function App() {
  const pathname = usePathname();

  let page: React.ReactNode;
  if (pathname === "/ventures/moja-finance") {
    page = <MojaFinance />;
  } else if (pathname === "/contact") {
    page = <Contact />;
  } else {
    page = <Home />;
  }

  return <ThemeProvider>{page}</ThemeProvider>;
}

export default App;
